/* Mega menu a due livelli: la categoria attiva cambia solo se il puntatore si ferma sulla voce,
   così muovendo il mouse verso le sottocategorie non si attraversano le altre categorie. */
(() => {
  const impostato = Number(document.querySelector('script[src*="custom-mega-menu"]')?.dataset.ritardo);
  const ATTESA = Number.isFinite(impostato) ? impostato : 180;

  const senzaHover = window.matchMedia('(hover: none)');

  const prepara = (lista) => {
    if (lista.dataset.customPronto) return;
    lista.dataset.customPronto = 'true';
    const voci = [...lista.querySelectorAll('.mega-menu__column > div')].filter((v) => v.querySelector(':scope > ul'));
    if (!voci.length) return;

    const attiva = (voce) => {
      voci.forEach((v) => v.classList.toggle('custom-attiva', v === voce));
    };
    attiva(voci[0]);

    voci.forEach((voce) => {
      let timer = null;
      const riavvia = () => {
        clearTimeout(timer);
        if (senzaHover.matches) return attiva(voce);
        timer = setTimeout(() => attiva(voce), ATTESA);
      };
      voce.addEventListener('mouseenter', riavvia);
      voce.addEventListener('mousemove', () => {
        if (!voce.classList.contains('custom-attiva')) riavvia();
      });
      voce.addEventListener('mouseleave', () => clearTimeout(timer));
      voce.addEventListener('focusin', () => attiva(voce));
      // su touch non c'è il passaggio del mouse: la categoria si attiva subito al tocco
      voce.addEventListener('pointerdown', (e) => {
        if (e.pointerType !== 'mouse') {
          clearTimeout(timer);
          attiva(voce);
        }
      });
    });
  };

  const avvia = () => document.querySelectorAll('.mega-menu__list').forEach(prepara);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', avvia);
  else avvia();
})();
